import { addStyles } from 'ethcss'
import { IStyles, colors, palette } from 'theme'

const Email: IStyles = {
    tableRow: {
        display: 'grid',
        gridTemplateColumns:
            '42px minmax(108px, .7fr) minmax(140px, .9fr) minmax(170px, 1.1fr) minmax(260px, 2fr) 36px',
        alignItems: 'center',
        minWidth: 900,
        minHeight: 72,
        padding: '8px 10px',
        borderBottom: `1px solid ${colors.greyLight}`,
        color: colors.blackLight,
        fontSize: 13,
        lineHeight: '18px',
        transition: 'background-color 140ms ease',
        '&:hover': {
            backgroundColor: '#F7F9FC',
        },
    },
    checkboxCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    dateCell: {
        display: 'flex',
        flexDirection: 'column',
        whiteSpace: 'nowrap',
    },
    statusCell: {
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        color: palette.brandBlue,
        fontSize: 12,
    },
    statusIcon: {
        width: 18,
        height: 18,
    },
    addressCell: {
        overflow: 'hidden',
        paddingRight: 16,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    subjectCell: {
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
        paddingRight: 16,
    },
    subject: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    recipient: {
        overflow: 'hidden',
        color: colors.greyEditor2,
        fontSize: 12,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    detailsButton: {
        appearance: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        border: 0,
        borderRadius: 4,
        background: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: colors.greyLight,
        },
    },
}

addStyles(Email)
export default Email
